import { render, staticRenderFns } from "./nxMobileButton.vue?vue&type=template&id=771107bc&scoped=true&"
import script from "./nxMobileButton.vue?vue&type=script&lang=js&"
export * from "./nxMobileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771107bc",
  null
  
)

export default component.exports